module.exports = __webpack_public_path__ + "img/Invasion-OVCA_10X_TPCP.3f5dd120.png";